import { Chip, makeStyles } from '@material-ui/core';
import { Kyc, VerificationStatus } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface KycResultProps {
  kyc: Kyc;
}

const useStyles = (color: string) =>
  makeStyles((theme) => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexWrap: 'wrap',
      '& > *': {
        margin: theme.spacing(0.5),
      },
      color: color,
      borderColor: color,
      backgroundColor: `${color}1A`,
      fontWeight: 600,
    },
  }));

export const KycResult = ({ kyc }: KycResultProps) => {
  const { palette } = useCustomTheme();

  const getKycResultIconProps = () => {
    switch (kyc.verification?.status) {
      case VerificationStatus.ACCEPTED:
        return { iconName: 'check', iconColor: palette.success.main };
      case VerificationStatus.REJECTED:
        return { iconName: 'error_outline', iconColor: palette.error.main };
      default:
        return { iconName: 'hourglass_empty', iconColor: palette.text.secondary };
    }
  };

  const iconProps = getKycResultIconProps();
  const classes = useStyles(iconProps.iconColor)();

  return (
    <Chip
      variant="outlined"
      classes={classes}
      label={<Text tId={'VIDEO_ID'} />}
      icon={
        <i className={'material-icons-outlined'} style={{ fontSize: 18, color: 'inherit' }}>
          {iconProps.iconName}
        </i>
      }
    />
  );
};
